import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {INavDisplay, INavItem} from "../../../cart/catalog/catalog-models";
import {UserService} from "../../../common/user.service";
import {LoggerService} from "../../../common/logger.service";
import {BaseComponent} from "../../../base.component";
import {CategoryService} from "../../../category/category.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {CartUtil} from "../../../cart/cart-util";

@Component({
    selector: 'nav-category',
    templateUrl: './nav-category.component.html',
    styleUrls: ['./nav-category.component.scss'],
    standalone: false
})
export class NavCategoryComponent extends BaseComponent implements OnInit {

    @Input() displaySize: string;
    @Input() horizontalWrap: boolean = false;
    @Output() readonly closeSideMenu = new EventEmitter();
    navCategories$: Observable<INavDisplay[]>;
    useLocaleOverride: boolean;

    constructor(
        loggerService: LoggerService,
        private userService: UserService,
        private categoryService: CategoryService
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        if(!this.displaySize) {
            this.displaySize = "lg";
        }
        this.navCategories$ = this.categoryService.getNavCategories().pipe(
            map((categories: INavItem[]) => categories.map(category => CartUtil.buildNavDisplay(category)))
        );
    }
}
